/* Product Badges Row v10 — 2 satır: üst(indirim+amorf) + alt(robot+ai)
   [PBR-AI-KONUM 2026-08-02] row2 (AI Fikir Alın) artık ÜRÜN ÖZELLİKLERİ (Bir bakışta /
   .dv-fixed-option3__specs) bloğunun ALTINA yerleşir (mobil+masaüstü aynı DOM);
   specs yoksa eski konum (güvenli ödeme/kargo altı) korunur. */
(function(){
  var done = false;

  function init(){
    if(done) return;
    var robot = document.querySelector('.hdt-product__robot-vacuum');
    var aiRoom = document.getElementById('ai-room-analyzer-v4');
    if(!robot && !aiRoom) return;

    // === SATIR 2: Robot + AI (kargo timeline altına) ===
    var row2 = document.createElement('div');
    row2.className = 'product-badges-row pbr-row2';
    row2.id = 'pbr-row2';

    if(robot){
      var rb = document.createElement('div');
      rb.className = 'pbr-item pbr-robot';
      // [PBR-AI-KONUM] lazy-bg sistemi div:not(.xbg)'de background-image'i !important ile siler;
      // JS ile uretilen rozet sistemin mekanizmasina uyar: .xbg + --original-bg-image
      rb.classList.add('xbg');
      rb.style.background = 'linear-gradient(135deg,#faf8f5,#f5f3f0)';
      rb.style.setProperty('--original-bg-image', 'linear-gradient(135deg,#faf8f5,#f5f3f0)');
      rb.innerHTML = '<div class="pbr-icon">\uD83E\uDD16</div><div class="pbr-text"><strong>Robot S\u00fcp\u00fcrgeye Uygun</strong><span>Kolayca temizlenebilir</span></div>';
      row2.appendChild(rb);
      robot.style.display = 'none';
    }

    if(aiRoom){
      var aiContent = aiRoom.innerHTML;
      var ab = document.createElement('div');
      ab.className = 'pbr-item pbr-ai';
      ab.classList.add('xbg'); // [PBR-AI-KONUM] lazy-bg: div:not(.xbg) arka plani siliyordu
      ab.style.background = 'linear-gradient(135deg,#1a1a2e,#16213e)';
      ab.style.setProperty('--original-bg-image', 'linear-gradient(135deg,#1a1a2e,#16213e)');
      ab.innerHTML = '<div class="pbr-icon">\u2728</div><div class="pbr-text"><strong>AI Fikir Al\u0131n</strong><span>Oda foto\u011fraf\u0131 y\u00fckle</span></div>';
      ab.style.cursor = 'pointer';
      ab.addEventListener('click', function(){
        var m = document.getElementById('pbr-ai-modal');
        if(m) m.style.display = 'flex';
      });
      row2.appendChild(ab);
      var modal = document.createElement('div');
      modal.id = 'pbr-ai-modal';
      modal.className = 'pbr-modal';
      modal.style.display = 'none';
      modal.innerHTML = '<div class="pbr-modal-overlay"></div><div class="pbr-modal-content"><button class="pbr-modal-close">\u00d7</button><div class="pbr-modal-body">' + aiContent + '</div></div>';
      document.body.appendChild(modal);
      modal.querySelector('.pbr-modal-overlay').addEventListener('click', function(){ modal.style.display='none'; });
      modal.querySelector('.pbr-modal-close').addEventListener('click', function(){ modal.style.display='none'; });
      aiRoom.style.display = 'none';
    }

    // Row2'yi güvenli ödeme veya kargo timeline'ın altına ekle
    var trustBadge = document.querySelector('.hdt-product__trust-badge, [data-type="img_trust"], .hdt-product__order-info, [data-type="order"]');
    // Kargo timeline arayalım
    var allItems = document.querySelectorAll('.hdt-product-info__item');
    var lastInfoItem = null;
    for(var i=0;i<allItems.length;i++){
      var dt = allItems[i].getAttribute('data-type');
      if(dt === 'img_trust' || dt === 'order' || allItems[i].querySelector('.payment-icons, .trust-badge, .shipping-timeline, .order-timeline')){
        lastInfoItem = allItems[i];
      }
    }
    if(!lastInfoItem){
      // Güvenli ödeme alanını bul
      var paymentEl = document.querySelector('.payment-icons, .hdt-product__payment, [class*="payment"], [class*="trust"]');
      if(paymentEl) lastInfoItem = paymentEl.closest('.hdt-product-info__item') || paymentEl;
    }
    var specsEl = document.querySelector('.dv-fixed-option3__specs'); // [PBR-AI-KONUM]
    if(specsEl && specsEl.parentNode){
      specsEl.parentNode.insertBefore(row2, specsEl.nextSibling);
    } else if(lastInfoItem && lastInfoItem.parentNode){
      lastInfoItem.parentNode.insertBefore(row2, lastInfoItem.nextSibling);
    } else if(robot && robot.parentNode){
      robot.parentNode.insertBefore(row2, robot);
    }

    // === SATIR 1: Amorf (üstte — fiyatın altına) ===
    var ozelOlcu = document.getElementById('ozel-olcu-plus');
    if(ozelOlcu){
      var row1 = document.createElement('div');
      row1.className = 'product-badges-row pbr-row1';
      row1.id = 'pbr-row1';

      // Amorf badge
      var amorf = document.createElement('div');
      amorf.className = 'pbr-item pbr-amorf';
      amorf.style.cursor = 'pointer';
      amorf.innerHTML = '<div class="pbr-amorf-blob"><svg viewBox="0 0 100 100" width="48" height="48"><path class="amorf-path" fill="url(#amorfGrad)" stroke="#d4af37" stroke-width="1.5"/><defs><linearGradient id="amorfGrad" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stop-color="#f7e4c8"/><stop offset="100%" stop-color="#e8c8a0"/></linearGradient></defs></svg><div class="pbr-finger">\u261D\uFE0F</div></div><div class="pbr-text"><strong>Amorf Dizayn</strong><span>\u015eeklini sen belirle \u2192</span></div>';

      var presets = [
        [0.85,0.78,0.65,0.58,0.55,0.58,0.65,0.78,0.88,0.92,0.90,0.82,0.72,0.65,0.62,0.65,0.72,0.82,0.90,0.95,0.92,0.85,0.75,0.68,0.65,0.68,0.75,0.85,0.92,0.95,0.90,0.82,0.72,0.65,0.60,0.58,0.60,0.65,0.72,0.80,0.88,0.92,0.90,0.85,0.78,0.70,0.65,0.62,0.60,0.62,0.68,0.75,0.82,0.88,0.92,0.90,0.85,0.80,0.75,0.78],
        [0.70,0.62,0.58,0.60,0.68,0.78,0.88,0.95,0.95,0.88,0.78,0.68,0.60,0.58,0.62,0.70,0.80,0.90,0.95,0.92,0.85,0.75,0.65,0.58,0.55,0.58,0.65,0.75,0.85,0.92,0.95,0.90,0.80,0.70,0.62,0.58,0.60,0.68,0.78,0.88,0.95,0.95,0.88,0.78,0.68,0.60,0.58,0.62,0.70,0.80,0.90,0.95,0.92,0.85,0.75,0.65,0.58,0.55,0.60,0.65],
        [0.90,0.88,0.82,0.72,0.62,0.55,0.52,0.55,0.62,0.72,0.82,0.90,0.95,0.95,0.90,0.82,0.72,0.62,0.55,0.52,0.55,0.62,0.72,0.82,0.90,0.95,0.95,0.90,0.85,0.78,0.70,0.62,0.58,0.58,0.62,0.70,0.78,0.85,0.90,0.92,0.90,0.85,0.78,0.70,0.62,0.58,0.55,0.55,0.58,0.65,0.72,0.80,0.87,0.92,0.95,0.95,0.92,0.88,0.85,0.88]
      ];
      var pathEl = amorf.querySelector('.amorf-path');
      var preIdx=0, N=60, frame=0;

      function makeAmorfPath(radii){
        var cx=50,cy=50,pts=[];
        for(var i=0;i<N;i++){var a=(i/N)*Math.PI*2;pts.push([cx+Math.cos(a)*radii[i]*42,cy+Math.sin(a)*radii[i]*42]);}
        var d='M'+pts[0][0].toFixed(1)+','+pts[0][1].toFixed(1);
        for(var i=0;i<N;i++){var p0=pts[(i-1+N)%N],p1=pts[i],p2=pts[(i+1)%N],p3=pts[(i+2)%N];d+=' C'+(p1[0]+(p2[0]-p0[0])*0.18).toFixed(1)+','+(p1[1]+(p2[1]-p0[1])*0.18).toFixed(1)+' '+(p2[0]-(p3[0]-p1[0])*0.18).toFixed(1)+','+(p2[1]-(p3[1]-p1[1])*0.18).toFixed(1)+' '+p2[0].toFixed(1)+','+p2[1].toFixed(1);}
        return d+'Z';
      }

      function animateBlob(){
        var t=(Math.sin(frame*0.008)+1)/2;
        var from=presets[preIdx%3],to=presets[(preIdx+1)%3],cur=[];
        for(var i=0;i<N;i++) cur.push(from[i]+(to[i]-from[i])*t);
        pathEl.setAttribute('d',makeAmorfPath(cur));
        frame++;
        if(frame%400===0) preIdx=(preIdx+1)%3;
        requestAnimationFrame(animateBlob);
      }
      animateBlob();

      amorf.addEventListener('click', function(){
    // 1. En/Boy otomatik 100 gir
    var wI=document.getElementById('ozel-olcu-width');
    var lI=document.getElementById('ozel-olcu-length');
    if(wI){wI.value='100';wI.dispatchEvent(new Event('input',{bubbles:true}));wI.dispatchEvent(new Event('change',{bubbles:true}));}
    if(lI){lI.value='100';lI.dispatchEvent(new Event('input',{bubbles:true}));lI.dispatchEvent(new Event('change',{bubbles:true}));}
    // 2. Shape amorf seç
    setTimeout(function(){
      var sel=document.getElementById('ozel-olcu-shape');
      if(sel){sel.value='amorf';sel.dispatchEvent(new Event('change',{bubbles:true}));}
      // 3. Amorf container'a scroll
      setTimeout(function(){
        var cont=document.getElementById('ozel-olcu-amorf-container');
        if(cont && cont.style.display!=='none') cont.scrollIntoView({behavior:'smooth',block:'center'});
        else{var sec=document.getElementById('ozel-olcu-plus');if(sec)sec.scrollIntoView({behavior:'smooth',block:'center'});}
      },400);
    },200);
  });

      row1.appendChild(amorf);

      // Row1'i fiyatın altına (buy_buttons veya price bloğundan sonra)
      var priceEl = document.querySelector('.hdt-product__price, [data-type="price"]');
      if(priceEl && priceEl.parentNode){
        priceEl.parentNode.insertBefore(row1, priceEl.nextSibling);
      }
    }

    done = true;
    grabDiscount();
  }

  function grabDiscount(){
    var row1 = document.getElementById('pbr-row1');
    if(!row1 || row1.querySelector('.pbr-discount')) return true;
    var disc = document.querySelector('.dolcevita-cart-discount-container');
    if(!disc || !disc.innerHTML.trim()) return false;
    var di = document.createElement('div');
    di.className = 'pbr-item pbr-discount';
    di.appendChild(disc);
    var badge = di.querySelector('.dolcevita-ultra-discount-badge');
    if(badge) badge.classList.add('show');
    row1.insertBefore(di, row1.firstChild);
    return true;
  }

  function waitAndInit(){
    init();
    var attempts=0;
    var iv=setInterval(function(){
      attempts++;
      var r1=document.getElementById('pbr-row1');
      if(r1 && !r1.querySelector('.pbr-discount')) grabDiscount();
      if((r1 && r1.querySelector('.pbr-discount'))||attempts>40) clearInterval(iv);
    },250);
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',waitAndInit);
  else waitAndInit();
})();
